// --- IMAGE IMPORTS ---
import mangoWineImg from '../assets/mango-wine.png';
import beetrootWineImg from '../assets/beetroot-wine.png';
import blackGrapeWineImg from '../assets/black-grapes-wine.png';
import chikkuWineImg from '../assets/chikku-wine.png';
import gingerWineImg from '../assets/ginger-wine.png';
import greenGrapeWineImg from '../assets/green-grapes-wine.png';
import jamunWineImg from '../assets/jamun-wine.png';
import pineappleWineImg from '../assets/pineapple-wine.png';
import raisinsWineImg from '../assets/kishmish-wine.png';
import watermelonWineImg from '../assets/watermelon-wine.png';
import whiteJamunWineImg from '../assets/white-jamun.png';
import roseWineImg from '../assets/Rose wine red.png';

// --- VIDEO IMPORTS ---
import beetrootVid1 from '../assets/beetroot-wine-video.mp4.mp4';
import beetrootVid2 from '../assets/beetroot-wine-video-2.mp4.mp4';

import greenGrapeVid1 from '../assets/green-grapes-wine-video.mp4.mp4';
import greenGrapeVid2 from '../assets/green-grapes-wine-video-2.mp4.mp4';

import blackGrapeVid1 from '../assets/black-grapes-wine-video.mp4.mp4';
import blackGrapeVid2 from '../assets/black-grapes-wine-video-2.mp4.mp4';

import gingerVid1 from '../assets/ginger-wine-video.mp4.mp4';
import gingerVid2 from '../assets/ginger-wine-video-2.mp4.mp4';

import jamunVid1 from '../assets/jamun-wine-video.mp4.mp4';
import jamunVid2 from '../assets/jamun-wine-video-2.mp4.mp4';

import chikkuVid1 from '../assets/chikku-wine-video.mp4.mp4';
import chikkuVid2 from '../assets/chikku-wine-video-2.mp4.mp4';

import pineappleVid1 from '../assets/pineapple-wine-video.mp4.mp4';
import pineappleVid2 from '../assets/pineapple-wine-video-2.mp4.mp4';

import kishmishVid1 from '../assets/kishmish-wine-video.mp4.mp4';
import kishmishVid2 from '../assets/kishmish-wine-video-2.mp4.mp4';

import roseVid1 from '../assets/rose-wine-video.mp4.mp4';
import roseVid2 from '../assets/rose-wine-video-2.mp4.mp4';

import mangoVid1 from '../assets/mango-wine-video.mp4.mp4';
import mangoVid2 from '../assets/mango-wine-video-2.mp4.mp4';

import watermelonVid1 from '../assets/watermelon-wine-video.mp4.mp4';
import watermelonVid2 from '../assets/watermelon-wine-video-2.mp4.mp4';

import whiteJamunVid1 from '../assets/white-jamun-wine-video.mp4.mp4';

export const wineData = [
    {
        id: "mango-wine",
        name: "Homemade - Mango Wine (Totapuri Mango)",
        size: "750 ml",
        image: mangoWineImg,
        videos: [mangoVid1, mangoVid2],
        ingredients: "Totapuri mango water, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in mango water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements mango sweetness",
            "Strong fruity aroma with tropical hints",
            "Smooth finish from mango, wheat, sugar",
            "Bold fruity flavor with Herbal Tea"
        ],
        flavor: [
            "Fruit-Forward: Ripe Totapuri mango",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Natural mango sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Appetizers, tropical fruits, spicy dishes"
        ],
        price: 250,
    },
    {
        id: "beetroot-wine",
        name: "Homemade - Beetroot Wine",
        size: "750 ml",
        image: beetrootWineImg,
        videos: [beetrootVid1, beetrootVid2],
        ingredients: "Fresh beetroot water, raisins, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in beetroot water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements beetroot earthiness",
            "Earthy aroma with hints of sweet raisins",
            "Smooth finish from beetroot, raisins, wheat, sugar",
            "Bold earthy flavor with Herbal Tea"
        ],
        flavor: [
            "Earthy: Fresh beetroot undertone",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Raisins and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Hearty salads, roasted vegetables, mild cheeses"
        ],
        price: 250,
    },
    {
        id: "black-grape-wine",
        name: "Homemade - Black Grape Wine",
        size: "750 ml",
        image: blackGrapeWineImg,
        videos: [blackGrapeVid1, blackGrapeVid2],
        ingredients: "Black grape water, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in grape water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements grape sweetness",
            "Fruity aroma with dark berries",
            "Smooth finish from black grapes, wheat, sugar",
            "Bold fruity flavor with Herbal Tea"
        ],
        flavor: [
            "Fruit-Forward: Ripe black grapes",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Grape and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Dark chocolate, grilled meats, strong cheeses"
        ],
        price: 450,
    },
    {
        id: "chikku-wine",
        name: "Homemade - Chikku Wine",
        size: "750 ml",
        image: chikkuWineImg,
        videos: [chikkuVid1, chikkuVid2],
        ingredients: "Chikku water, raisins, wheat, sugar, and Herbal Tea",
        fermentation: "Natural sugars in chikku water and sugar converted to alcohol by yeast.",
        twist: "Herbal Tea adds a caramel and spice twist.",
        tastingTerms: [
            "Balanced acidity complements chikku sweetness",
            "Fruity aroma with caramel and tropical hints",
            "Smooth finish from chikku, raisins, wheat, sugar",
            "Bold fruity flavor with Herbal Tea"
        ],
        flavor: [
            "Fruit-Forward: Ripe chikku with raisins",
            "Spicy: Subtle Herbal Tea spice",
            "Sweet: Chikku and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Fruit salads, light desserts, mild cheeses"
        ],
        price: 250,
    },
    {
        id: "ginger-wine",
        name: "Homemade - Ginger Wine",
        size: "750 ml",
        image: gingerWineImg,
        videos: [gingerVid1, gingerVid2],
        ingredients: "Fresh ginger water, raisins, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in ginger water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements ginger spice",
            "Spicy aroma with ginger and cinnamon",
            "Smooth finish from ginger, raisins, wheat, sugar",
            "Bold spicy flavor with cinnamon"
        ],
        flavor: [
            "Spicy: Ginger and cinnamon",
            "Sweet: Raisins and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Spicy dishes, grilled meats, strong cheeses"
        ],
        price: 450,
    },
    {
        id: "green-grape-wine",
        name: "Homemade - Green Grape Wine",
        size: "750 ml",
        image: greenGrapeWineImg,
        videos: [greenGrapeVid1, greenGrapeVid2],
        ingredients: "Green grape water, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in grape water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements grape freshness",
            "Fresh aroma with green apple and spice",
            "Smooth finish from grapes, wheat, sugar",
            "Bold fruity flavor with cinnamon"
        ],
        flavor: [
            "Fruit-Forward: Fresh green grapes",
            "Spicy: Cinnamon notes",
            "Sweet: Grape and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Light salads, seafood, mild cheeses"
        ],
        price: 450,
    },
    {
        id: "green-grape-wine-4-year-aged",
        name: "Homemade - Green Grape Wine (4-Year Aged)",
        size: "750 ml",
        image: greenGrapeWineImg,
        videos: [greenGrapeVid1, greenGrapeVid2],
        ingredients: "Green grape water, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in grape water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements grape freshness",
            "Fresh aroma with green apple and spice",
            "Smooth finish from grapes, wheat, sugar",
            "Bold fruity flavor with cinnamon"
        ],
        flavor: [
            "Fruit-Forward: Fresh green grapes",
            "Spicy: Cinnamon notes",
            "Sweet: Grape and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Light salads, seafood, mild cheeses"
        ],
        price: 1000,
    },
    {
        id: "jamun-wine",
        name: "Homemade - Jamun Wine",
        size: "750 ml",
        image: jamunWineImg,
        videos: [jamunVid1, jamunVid2],
        ingredients: "Jamun water, Jamun seeds, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in Jamun water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements Jamun tartness",
            "Rich aroma with dark berries and spice",
            "Smooth finish from Jamun, wheat, sugar",
            "Bold fruity flavor with cinnamon"
        ],
        flavor: [
            "Fruit-Forward: Ripe Jamun",
            "Spicy: Cinnamon notes",
            "Sweet: Jamun and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Grilled meats, dark chocolate, strong cheeses"
        ],
        price: 500,
    },
    {
        id: "jamun-wine-4-year-aged",
        name: "Homemade - Jamun Wine (4-Year Aged)",
        size: "750 ml",
        image: jamunWineImg,
        videos: [jamunVid1, jamunVid2],
        ingredients: "Jamun water, Jamun seeds, wheat, sugar, and cinnamon",
        fermentation: "Natural sugars in Jamun water and sugar converted to alcohol by yeast.",
        twist: "Cinnamon adds a warm, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements Jamun tartness",
            "Rich aroma with dark berries and spice",
            "Smooth finish from Jamun, wheat, sugar",
            "Bold fruity flavor with cinnamon"
        ],
        flavor: [
            "Fruit-Forward: Ripe Jamun",
            "Spicy: Cinnamon notes",
            "Sweet: Jamun and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Grilled meats, dark chocolate, strong cheeses"
        ],
        price: 800,
    },
    {
        id: "pineapple-wine",
        name: "Homemade - Pineapple Wine",
        size: "750 ml",
        image: pineappleWineImg,
        videos: [pineappleVid1, pineappleVid2],
        ingredients: "Pineapple water, wheat, sugar, and ginger",
        fermentation: "Natural sugars in pineapple water and sugar converted to alcohol by yeast.",
        twist: "Ginger adds a refreshing, spicy twist.",
        tastingTerms: [
            "Balanced acidity complements pineapple tanginess",
            "Tropical aroma with pineapple and spice",
            "Smooth finish from pineapple, wheat, sugar",
            "Bold fruity flavor with ginger"
        ],
        flavor: [
            "Fruit-Forward: Ripe pineapple",
            "Spicy: Ginger notes",
            "Sweet: Pineapple and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Fruit salads, seafood, light desserts"
        ],
        price: 350,
    },
    {
        id: "raisins-wine",
        name: "Homemade - Raisins Wine",
        size: "750 ml",
        image: raisinsWineImg,
        videos: [kishmishVid1, kishmishVid2],
        ingredients: "Raisins, wheat, sugar, water, and vanilla",
        fermentation: "Natural sugars in raisins and sugar converted to alcohol by yeast.",
        twist: "Vanilla adds a smooth, aromatic twist.",
        tastingTerms: [
            "Balanced acidity complements raisin sweetness",
            "Fruity aroma with dried fruit and vanilla",
            "Smooth finish from raisins, wheat, sugar",
            "Bold fruity flavor with vanilla"
        ],
        flavor: [
            "Fruit-Forward: Sweet raisins",
            "Aromatic: Vanilla notes",
            "Sweet: Raisins and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Cheese platters, desserts, roasted nuts"
        ],
        price: 350,
    },
    {
        id: "watermelon-wine",
        name: "Homemade - Watermelon Wine",
        size: "750 ml",
        image: watermelonWineImg,
        videos: [watermelonVid1, watermelonVid2],
        ingredients: "Watermelon water, raisins, wheat, sugar, and mint",
        fermentation: "Natural sugars in watermelon and sugar converted to alcohol by yeast.",
        twist: "Mint adds a refreshing, herbal twist.",
        tastingTerms: [
            "Balanced acidity complements watermelon freshness",
            "Light fruity aroma with mint",
            "Smooth finish from watermelon, raisins, wheat, sugar",
            "Bold fruity flavor with mint"
        ],
        flavor: [
            "Fruit-Forward: Fresh watermelon",
            "Herbal: Mint notes",
            "Sweet: Watermelon and sugar sweetness",
            "Unique: Slight grainy texture from wheat"
        ],
        serving: [
            "Chilled: Best served chilled",
            "Pairings: Light salads, grilled vegetables, mild cheeses"
        ],
        price: 250,
    },
    {
        id: "white-jamun-wine",
        name: "Homemade - White Jamun Wine",
        size: "750 ml",
        image: whiteJamunWineImg,
        videos: [whiteJamunVid1], 
        ingredients: "White jamun fruit, wheat, sugar, and Herbal Tea",
        fermentation: "Sugars in white jamun ferment into alcohol, creating a crisp and subtly aromatic wine.",
        twist: "Herbal Tea adds gentle warmth and balances the fruit’s tanginess with subtle spice.",
        tastingTerms: [
            "Lively, refreshing acidity that brightens fruit flavors",
            "Delicate floral, citrus, and tropical aromas",
            "Light-bodied yet smooth balance of fruit and grain",
            "Elegant and distinctive compared to deeper berry wines"
        ],
        flavor: [
            "Tropical & Citrus: Mildly tart jamun with hints of lime and pear",
            "Floral: Hints of jasmine and white blossoms",
            "Dry or Semi-Sweet: Adjustable sugar for crispness or roundness",
            "Silky & Refreshing: Velvety, easy-drinking texture"
        ],
        serving: [
            "Chilled: Best served ice-cold",
            "Pairings: Grilled seafood, white sauce dishes, goat cheese, light salads"
        ],
        price: 350,
    },
    {
        id: "rose-wine",
        name: "Homemade - Rosé Wine with Black Raisins & Rose Petals",
        size: "750 ml",
        image: roseWineImg, 
        videos: [roseVid1, roseVid2], 
        ingredients: "Black raisins, wheat, sugar, herbal tea, red & pink rose petals",
        fermentation: "Soaked raisins and sugar are fermented; rose petals are gently macerated to infuse floral notes.",
        twist: "Herbal tea provides subtle spice and caramel undertones; rose petals add elegance.",
        tastingTerms: [
            "Crisp acidity highlights berry and floral tones",
            "Floral bouquet from rose petals with rich raisin sweetness",
            "Balanced depth from raisins, refined by rose",
            "Elegant body with expressive floral aroma"
        ],
        flavor: [
            "Berry-Forward: Strawberry, raspberry, raisin sweetness",
            "Floral: Rose petals and gentle herbal undertones",
            "Dry or Semi-Sweet: Adjustable sweetness to taste",
            "Silky: Smooth, velvety finish from slow fermentation"
        ],
        serving: [
            "Chilled: Always served ice-cold",
            "Pairings: Seafood, grilled vegetables, creamy pasta, soft cheeses like Brie"
        ],
        price: 450,
    }
];